import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="av34oprykyzk">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="at8w8axvizcd">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="1un35lus01xc">
          🎁 4 Free Bonuses Included
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-blush" data-id="element-19" data-mp="5wrzisclzcno">
          Included with your toolkit
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3t06f8q0p237d">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "16px",
          paddingBottom: "16px"
        }} data-id="element-21" data-mp="1ma8ml10nv43r" data-mpi={i}>
              <img src={b.image} alt="" aria-hidden="true" loading="lazy" className="aspect-[4/5] w-20 shrink-0 self-start rounded-lg object-cover shadow-[0_10px_18px_-8px_rgba(17,24,39,0.45)] sm:w-24" data-id="element-22" data-mp="3n5erqeiqbp9d" />
              <div className="flex min-w-0 flex-col" data-id="element-23" data-mp="2ugr0m2bau5nw">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="2uibvjt1izqma">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-25" data-mp="38htngha4bjzv">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="npi4kelqg0tp" /> Bonus {b.n}
                  </span>
                  <span className="inline-flex items-baseline gap-1.5 whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="ir6tk0jpbk9w">
                    <s className="text-plum/45" aria-label={`Regular price ${b.price}`} data-id="element-28" data-mp="3cjfxta97slhv">${b.price}</s>
                    <span className="text-blush" data-id="element-29" data-mp="3hhhqmmwfzz6j">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-30" data-mp="3ljcrxredickb">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-31" data-mp="3qiph4ispvvq2">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-sm font-semibold text-plum/60" data-id="element-32" data-mp="2ttq46qh6u5rj">
          <SmartphoneIcon className="h-4 w-4 text-grape" aria-hidden="true" data-id="element-33" data-mp="2xutllhevw9uv" />
          Access everything from your phone, tablet or computer.
        </p>

        <div className="mt-6 rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-34" data-mp="37jjuld8ccy3d">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-35" data-mp="2a2d1l1bl67sx">
            🎁 All 4 bonuses are <span className="text-blush-deep" data-id="element-36" data-mp="2f1pqdrm0poy5">included free</span> with the 6-volume toolkit
          </p>
        </div>
      </div>
    </section>;
}